module.exports = __webpack_public_path__ + "img/ALDEAO.458031cf.jpg";